var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5C6.75 8.89239 7.30312 10.2277 8.28769 11.2123C9.27226 12.1969 10.6076 12.75 12 12.75C13.3924 12.75 14.7277 12.1969 15.7123 11.2123C16.6969 10.2277 17.25 8.89239 17.25 7.5C17.25 6.10761 16.6969 4.77226 15.7123 3.78769C14.7277 2.80312 13.3924 2.25 12 2.25C10.6076 2.25 9.27226 2.80312 8.28769 3.78769C7.30312 4.77226 6.75 6.10761 6.75 7.5ZM19.5 21.75H3.75C3.55109 21.75 3.36032 21.671 3.21967 21.5303C3.07902 21.3897 3 21.1989 3 21V18.75C3 17.7554 3.39509 16.8016 4.09835 16.0983C4.80161 15.3951 5.75544 15 6.75 15H17.25C18.2446 15 19.1984 15.3951 19.9016 16.0983C20.6049 16.8016 21 17.7554 21 18.75V21C21 21.1989 20.921 21.3897 20.7803 21.5303C20.6397 21.671 20.4489 21.75 20.25 21.75H19.5Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.7b50449c217c10ea7d9aaa9b2d0d598e.svg";
export { ForwardRef as ReactComponent };